import React from "react";
import { TypeFieldComponent } from "./components/MyTextField";

export interface PropsPayLoadSendEmail {
  data: {
    email?: string;
  };
}

export interface PropsPayLoadGetInTouch {
  data: {
    name: string;
    email: string;
    phone?: string;
    text: string;
    turnstileToken: string;
    website?: string;
    formStartedAt: number;
  };
}

//Photo
export interface PropsInitialStatePhotoSlice {
  getPhotos: IPhoto[] | [];
  showPhotos: IPhoto[];
  categoryPhotosBtn: string | null;
  loading: boolean;
  error: string | undefined;
  openModalWithImage: boolean;
  dataForImageModal: string;
  openChangeSortPhotos: boolean;
  photoCategories: ICategory[];
}

export interface PropsArrPhotos {
  payload: IPhoto[];
}

export interface IPhoto {
  type: string;
  image: string;
  alt?: string;
  _id: string;
  order: number;
  createdAt: string;
}

export interface IPhotosCategoryInMainPage {
  name: string;
  type: string | null;
  onClick: any;
  id: string;
}

export interface PropsPhotos {
  photoPostPage: string;
  onClick?: any;
  hide?: any;
  buttonName?: string | null;
}

export interface PropsPhoto {
  image: IPhoto;
  imageIndex: number;
  photoPostPage: string;
  setRef?: any;
  variants?: any;
  handleDeletePhoto: (photoId: string, arrPhoto: IPhoto[]) => any;
  handleChangeOrderPhoto?: (currentPhoto: IPhoto, duration: string) => void;
  showPhotos: IPhoto[];
}

export interface PropsDeletePhoto {
  photoId: string;
  type: string;
  path: string;
}

//Route
export interface IRoute {
  index?: boolean;
  component: any;
  path: string;
  subPath?: Array<string>;
  name: string;
  isAdmin?: boolean;
  isAuth?: boolean;
  protectRouteBasket?: boolean;
  withOutHeaderAndFooter?: boolean;
  protectOrderSuccess?: boolean;
}

export interface PropsProtectedRoute {
  authorization: boolean;
  children: any;
  redirectTo?: string;
}

//Paket
export interface PropsInitialStatePacketSlice {
  loading: {
    getArrPackets: boolean;
    getPacketsPinned: boolean;
    createPacket: boolean;
    getPacketWithDetailsDescription: boolean;
  };
  error: {
    newPacket: string;
    packets: string;
    packetDetail: string;
    packetsPinned: string;
  };
  getPackets: IPacket[];
  getPinnedPackets: IPacket[];
  packetWithDetailsDescription: IPacket | null;
  packetsCategories: ICategory[];
  packetInBasket: IPacket[];
  basketIsNotEmpty: boolean;
}

export interface IPacket {
  namePacket: string;
  countLocations: string;
  getFromPhotosession: string;
  duration: string;
  shortDescription: string;
  photosessionType: string;
  price: string;
  image: string;
  pinned: boolean;
  imageDescription: string;
  imageDescriptionMobile: string;
  description: string;
  descriptionEN: string;
  getFromPhotosessionEN: string;
  _id: string;
  createdAt: string;
}

export interface PropsPopularPackets {
  editStyleForPrice?: boolean;
}

export interface PropsPacketsInBasket {
  packetInBasket: IPacket[];
  onClickDeletePacket: (id: string) => void;
}

export interface PropsPackets {
  getPackets: IPacket[];
  editStyleForPrice?: boolean;
  item: any;
  container: any;
  styleContainer: string;
}

export interface ICategory {
  title: string;
  nameRU: string;
  nameEN: string;
  _id: string;
}

//User
export interface IUser {
  name: string;
  email: string;
  phone?: string;
  prevOrders?: [];
  passwordChange: boolean;
  _id: string;
  isActivated: boolean;
  role: string;
  orders?: Array<string>;
}

export interface PropsInitialStateUserSlice {
  user: IUser;
  auth: boolean;
  loading: {
    register: boolean;
    login: boolean;
    passwordChange: boolean;
    logOut: boolean;
    getUserInfo: boolean;
    updateUser: boolean;
  };
  error: string;
  adminEmail: string;
  isRegister: boolean;
  showError: boolean;
  passwordRecoveryEnabled: boolean;
}

export interface IUserProfile {
  name: string;
  email: string;
  phone: string | undefined;
  _id?: string;
  orders?: [];
}

export interface IUpdateUser {
  name?: string;
  email?: string;
  phone?: string;
  orders?: Array<string>;
}

export interface IUserResponse {
  accessToken: string;
  user?: IUser;
}

export interface ICreateUser {
  name: string;
  email: string;
  password: string;
  role: string;
}

export interface ILoginUser {
  email: string;
  password: string;
  navigate: any;
}

export interface IRefreshTokenResponse {
  accessToken: string;
}

export interface PropsLogin {
  email: string;
  password: string;
}

export interface PropsRegister {
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export interface PropsAuthForm {
  message?: string;
  completed?: boolean;
  titleAuthorization: string;
  textQuestion?: string;
  textAnswer?: string;
  pathOnAnotherAuthorization?: string;
  children?: React.ReactNode;
  initialValues: Object;
  validationSchema: any;
  textButton: string;
  handleSubmit: any;
  error: string;
  loading: boolean;
  showError: boolean;
  showLinkForgotPassword?: boolean;
}

//Orders
export interface IMeOrders {
  orderNumber: string;
  packets: IPacketInOrder[];
  text: string;
  completed: boolean;
}

export interface IOrderData {
  orderNumber: string;
  text: string;
  packets: IPacketInOrder[];
  createdAt: string;
  completed: boolean;
  user: IUserProfile;
}

export interface INewOrder {
  orderNumber: string;
  text?: string;
  packets: IPacketInOrder[];
  name: string;
  email: string;
  phone: string;
  // user: IUserProfile;
}

export interface IPacketInOrder {
  namePacket: string;
  photosessionType: string;
  price: string;
  requestedDate?: string;
  requestedDateLabel?: string;
  link?: string;
}

export interface PropsInitialStateOrderSlice {
  dataOrders: IOrderData[];
  meOrders: Array<IMeOrders>;
  confirmSendOrder: boolean;
  orderSuccessfullySent: boolean;
  loading: {
    newOrder: boolean;
    getOrders: boolean;
    getMeOrders: boolean;
  };
  error: {
    newOrder: string;
    getOrders: string;
    getMeOrders: string;
  };
}

export interface PropsOrderCheckout {
  orderInMyProfile?: boolean;
  orderData: IPacketInOrder[];
  orderNumber?: string;
  title: string;
}

export interface PropsDataUser {
  title: string;
  children: React.ReactNode;
}

//Admin
export interface ILinkListAdmin {
  title: string;
  path: string;
}

export interface PropsAddNewPhoto {
  image: string;
  photo?: File | null;
  type: string;
  alt: string;
  order?: number | null;
}

export interface PropsAddNewArticle {
  description: string;
}

export interface PropsAdminContainer {
  children: React.ReactNode;
  title: string;
  linkBack: { title: string; link: string };
}

//other interfaces
export interface PropsNavMenu {
  handlerOpenAndCloseBurgerMenu: () => void;
  openBurgerMenu: boolean;
}

export interface PropsContactMeForm {
  title: string;
}

export interface PropsMessageToTheUser {
  title: string;
  text?: string;
  icon?: string;
  onClose: () => void;
}

export interface ITable {
  table: ITablesPhotoProducts[];
}

export interface PropsPopup {
  onClick?: () => void;
  children: React.ReactNode;
  openPopup: boolean;
  allowPinchZoom?: boolean;
}

export interface ITablesPhotoProducts {
  title?: Array<string>;
  product?: IProduct[];
}

export interface IProduct {
  size: string;
  printQuality?: string;
  price: string;
  type?: string;
}

export interface PropsInitialStateAppSlice {
  loading: {
    sendMessageGetInTouch: boolean;
    instagram: boolean;
    sendEmail: boolean;
  };
  confirmationGetInTouch: boolean;
  errorGetInTouch: boolean;
  displayPricePackets: IPacket[];
  confirmationSendEmail: boolean;
  errorSendEmail: boolean;
  language: string;
  error: {
    // instagram: string;
  };
  // instagramProfile: PostInstagramProfile[];
}

export interface PostInstagramProfile {
  caption: string;
  id: string;
  media_type: string;
  media_url: string;
  permalink: string;
  timestamp: string;
  username: string;
}

export interface PropsMyTextField {
  autoComplete?: string;
  autoCapitalize?: string;
  spellCheck?: boolean;
  nameLabel: React.ReactNode;
  label?: boolean;
  type: string;
  rows?: number;
  name: string;
  component: TypeFieldComponent;
  id: string;
  checkbox?: boolean;
  editStyleContainer?: string;
  editStyleField?: string;
  select?: boolean;
  options?: Array<{ value: string; title: string; hidden?: boolean }>;
  placeholder?: string;
}
export interface PropsBoolean {
  payload: boolean;
}

export interface PropsRandomPhotos {
  payload: {
    arr: IPhoto[];
    n: number;
  };
}

export interface ILink {
  name?: string;
  path?: string;
  logo?: string;
  select?: ISubLink[];
}

export interface ISubLink {
  name: string;
  pathSelect: string;
  type?: string;
  title: string;
}

export interface IArrSlides {
  desktop: string;
  mobile: string;
}

export interface IOrderFields {
  name: string;
  email: string;
  phone: string | undefined;
  text?: string;
  website?: string;
}

export interface ISessionRequestFields extends IOrderFields {
  babyArrived: boolean;
  newbornDate: string;
  packageTimeframes: Record<string, string>;
}

export interface PropsDataTabs {
  labelName: string;
  nameSession: string;
  id: string;
  idContent: string;
  getText: PropsText[];
  metaTitle: string;
  metaDescription: string;
  metaImage: string;
}

export interface PropsText {
  _id: string;
  text: string;
  typePhotoSession: string;
}

export interface PropsEditorComponent {
  setContent: any;
}

export interface PropsArrTabs {
  value: string;
  title: string;
  hidden?: boolean;
}

//Blog
export interface PropsInitialStateBlogSlice {
  blogArticles: IBlogArticle[] | [];
  articleDetails: IBlogArticle;
  loading: {
    getBlog: boolean;
    getArticleDetail: boolean;
    articlesURL: boolean;
  };
  error: {
    getBlog: string;
    getArticleDetail: string;
    articlesURL: string;
  };
  articlesURL: [];
}

//BlogArticle
export interface IBlogArticle {
  title: string;
  url: string;
  imagePrev: string;
  typePhotoSession: string;
  createdAt: string;
  details: {
    images: Array<string>;
    description: string;
  };
}

//enum
export enum PhotoPostPage {
  mainPage = "main",
  photoGalleryPage = "photoGallery",
}

export interface SocialLink {
  name: string;
  href: string;
  icon: string;
  aria: string;
}
